var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [[_vm.$permissionAbility(_vm.ATTENDANCE_SEE_ALL_REPORT, _vm.permissions) ? [_c('b-card', [_c('validation-observer', {
    ref: "generateAllAttendanceValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.generateAllAttendanceReport('preview');
      }
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "",
      "label-for": "empId"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "User",
      "vid": "empId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          staticClass: "w-100",
          attrs: {
            "id": "empId",
            "options": _vm.filterEmpIdOption,
            "reduce": function reduce(item) {
              return item.id;
            },
            "label": "name",
            "placeholder": "Select Employee"
          },
          on: {
            "input": function input($event) {
              return _vm.loadAttendance('user');
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.selectEmpId,
            callback: function callback($$v) {
              _vm.selectEmpId = $$v;
            },
            expression: "selectEmpId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 53102306)
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "3",
      "lg": "2"
    }
  }, [_c('v-select', {
    staticClass: "w-100",
    attrs: {
      "options": _vm.statusIdOption,
      "reduce": function reduce(item) {
        return item.value;
      },
      "label": "name",
      "placeholder": "Select Status"
    },
    on: {
      "input": function input($event) {
        return _vm.loadAttendance();
      }
    },
    model: {
      value: _vm.filterStatusId,
      callback: function callback($$v) {
        _vm.filterStatusId = $$v;
      },
      expression: "filterStatusId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-select', {
    staticClass: "w-100",
    attrs: {
      "options": _vm.filterDepartmentIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Department",
      "multiple": ""
    },
    on: {
      "input": function input($event) {
        return _vm.loadAttendance('department');
      }
    },
    model: {
      value: _vm.selectDepartmentId,
      callback: function callback($$v) {
        _vm.selectDepartmentId = $$v;
      },
      expression: "selectDepartmentId"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control w-100",
    attrs: {
      "placeholder": "Select Date Range",
      "config": {
        mode: 'range',
        defaultDate: [_vm.filterStartDate, _vm.filterEndDate]
      }
    },
    on: {
      "input": function input($event) {
        return _vm.loadAttendance('date');
      }
    },
    model: {
      value: _vm.filterRangeDate,
      callback: function callback($$v) {
        _vm.filterRangeDate = $$v;
      },
      expression: "filterRangeDate"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-end mt-2"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255,255,255,0.15)',
      expression: "'rgba(255,255,255,0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "ml-1 mb-1 w-30 w-sm-auto",
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": !_vm.filterStartDate || !_vm.filterEndDate
    }
  }, [_vm.isAttendanceReportGenerating ? [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Report Generating .. ")] : [_vm._v(" Generate Report ")]], 2)], 1)], 1)], 1)], 1)] : _vm.$permissionAbility(_vm.ATTENDANCE_SEE_SELF_REPORT, _vm.permissions) ? [_c('b-card', {
    attrs: {
      "title": "Personal Report"
    }
  }, [_c('b-row', {
    staticClass: "align-items-center"
  }, [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "6",
      "lg": "5"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control w-100",
    attrs: {
      "placeholder": "Filter Date Range",
      "config": {
        mode: 'range',
        defaultDate: [_vm.filterStartDate, _vm.filterEndDate]
      }
    },
    model: {
      value: _vm.filterRangeDate,
      callback: function callback($$v) {
        _vm.filterRangeDate = $$v;
      },
      expression: "filterRangeDate"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "3",
      "lg": "2"
    }
  }, [_c('b-button', {
    staticClass: "w-30",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.filterRangeDate
    },
    on: {
      "click": function click($event) {
        return _vm.generateAllAttendanceReport('preview');
      }
    }
  }, [_vm.isAttendanceReportGenerating ? [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Report Generating .. ")] : [_vm._v(" Generate Report ")]], 2)], 1)], 1)], 1)] : _vm._e()], _vm.attendanceData ? _c('b-card', [_c('div', {
    staticClass: "attendance-preview p-3 border mx-auto col-12 col-md-10",
    class: _vm.$store.state.app.isDark ? 'dark-layout' : ''
  }, [_c('h3', {
    staticClass: "text-center mb-4"
  }, [_vm._v(" " + _vm._s(_vm.companyName) + " ")]), _vm._l(_vm.attendanceData, function (attendance, index) {
    var _attendance$user$desi, _attendance$user$depa, _attendance$user$depa2, _attendance$user$depa3, _attendance$user$empl, _attendance$attendanc, _attendance$attendanc2, _attendance$attendanc3, _attendance$attendanc4, _attendance$duty_hour, _attendance$attendanc5, _attendance$attendanc6, _attendance$attendanc7, _attendance$attendanc8, _attendance$attendanc9, _attendance$attendanc10, _attendance$attendanc11, _attendance$attendanc12, _attendance$duty_hour2, _attendance$attendanc13, _attendance$attendanc14, _attendance$attendanc15, _attendance$attendanc16, _attendance$duty_hour3, _attendance$attendanc17, _attendance$attendanc18, _attendance$duty_hour4, _attendance$attendanc19, _attendance$attendanc20, _attendance$attendanc21, _attendance$attendanc22, _attendance$duty_hour5;
    return _c('div', {
      key: index,
      staticClass: "mb-5"
    }, [_c('div', {
      staticClass: "table-responsive mb-2"
    }, [_c('table', {
      staticClass: "table table-bordered text-center attendance-table mb-3"
    }, [_c('tr', [_c('td', [_c('b', [_vm._v("Employee Name:")])]), _c('td', [_vm._v(_vm._s(attendance.user.name))]), _c('td', [_c('b', [_vm._v("Designation:")])]), _c('td', [_vm._v(_vm._s((_attendance$user$desi = attendance.user.designation) === null || _attendance$user$desi === void 0 ? void 0 : _attendance$user$desi.name))]), _c('td', [_c('b', [_vm._v("Employee ID:")])]), _c('td', [_vm._v(_vm._s(attendance.user.employee_number))])]), _c('tr', [_c('td', [_c('b', [_vm._v("Division:")])]), _c('td', [_vm._v(_vm._s((_attendance$user$depa = attendance.user.department) === null || _attendance$user$depa === void 0 ? void 0 : (_attendance$user$depa2 = _attendance$user$depa.division) === null || _attendance$user$depa2 === void 0 ? void 0 : _attendance$user$depa2.name))]), _c('td', [_c('b', [_vm._v("Department:")])]), _c('td', [_vm._v(_vm._s((_attendance$user$depa3 = attendance.user.department) === null || _attendance$user$depa3 === void 0 ? void 0 : _attendance$user$depa3.name))]), _c('td', [_c('b', [_vm._v("Employee Type:")])]), _c('td', [_vm._v(_vm._s(attendance.user.status ? (_attendance$user$empl = attendance.user.employee_type) === null || _attendance$user$empl === void 0 ? void 0 : _attendance$user$empl.name : 'Inactive'))])])])]), _c('div', {
      staticClass: "table-responsive mb-2"
    }, [_c('table', {
      staticClass: "table table-bordered text-center attendance-table mb-3",
      staticStyle: {
        "border-collapse": "collapse"
      }
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Check In")]), _c('th', [_vm._v("Check Out")]), _c('th', [_vm._v("Extra/Less Duty")]), _c('th', [_vm._v("Overtime")]), _c('th', [_vm._v("Total Worked")]), _c('th', [_vm._v("Expected Duty")]), _c('th', [_vm._v("Remarks")])])]), _c('tbody', _vm._l(attendance.daily_attendances_reports, function (day, i) {
      return _c('tr', {
        key: i,
        class: {
          'status-half-day': day.half_day_leave,
          'status-delay': day.sort_name === 'D',
          'status-ed': day.sort_name === 'ED',
          'status-fullday': day.sort_name === 'L'
        }
      }, [_c('td', [_vm._v(_vm._s(day.date))]), _c('td', [_c('span', [_vm._v(_vm._s(day.sort_name))]), day.half_day_leave ? _c('span', {
        staticClass: "text-warning font-weight-bold"
      }, [_vm._v("(HD)")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(_vm.formatTime(day.first_check_in)))]), _c('td', [_vm._v(_vm._s(_vm.formatTime(day.last_check_out)))]), _c('td', [_vm._v(_vm._s(day.extra_less_duty_hours))]), _c('td', [_vm._v(_vm._s(day.over_time_hours))]), _c('td', [_vm._v(_vm._s(day.total_worked_hours))]), _c('td', [_vm._v(_vm._s(day.expected_duty_hours))]), _c('td', [_vm._v(_vm._s(day.remarks))])]);
    }), 0)])]), _c('div', {
      staticClass: "text-center mb-2 font-weight-bold"
    }, [_vm._v(" Attendance Summary ")]), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-bordered info-summery-table mb-5 text-center"
    }, [_c('tr', [_c('td', [_c('b', [_vm._v("Presents (P)")])]), _c('td', [_vm._v(_vm._s(((_attendance$attendanc = attendance.attendances_statuses) === null || _attendance$attendanc === void 0 ? void 0 : (_attendance$attendanc2 = _attendance$attendanc.presents) === null || _attendance$attendanc2 === void 0 ? void 0 : _attendance$attendanc2.attendance_status_count) || 0))]), _c('td', {
      staticClass: "status-fullday"
    }, [_c('b', [_vm._v("Full Day Leave (L)")])]), _c('td', {
      staticClass: "status-fullday"
    }, [_vm._v(_vm._s(((_attendance$attendanc3 = attendance.attendances_statuses) === null || _attendance$attendanc3 === void 0 ? void 0 : (_attendance$attendanc4 = _attendance$attendanc3.leaves) === null || _attendance$attendanc4 === void 0 ? void 0 : _attendance$attendanc4.attendance_status_count) || 0))]), _c('td', [_c('b', [_vm._v("Expected Duty Hour")])]), _c('td', [_vm._v(_vm._s(((_attendance$duty_hour = attendance.duty_hours) === null || _attendance$duty_hour === void 0 ? void 0 : _attendance$duty_hour.expected_duty_hours) || '00:00'))])]), _c('tr', [_c('td', {
      class: ((_attendance$attendanc5 = attendance.attendances_statuses) === null || _attendance$attendanc5 === void 0 ? void 0 : (_attendance$attendanc6 = _attendance$attendanc5.absents) === null || _attendance$attendanc6 === void 0 ? void 0 : _attendance$attendanc6.attendance_status_count) > 0 ? 'status-absent' : ''
    }, [_c('b', [_vm._v("Absent (A)")])]), _c('td', {
      class: ((_attendance$attendanc7 = attendance.attendances_statuses) === null || _attendance$attendanc7 === void 0 ? void 0 : (_attendance$attendanc8 = _attendance$attendanc7.absents) === null || _attendance$attendanc8 === void 0 ? void 0 : _attendance$attendanc8.attendance_status_count) > 0 ? 'status-absent' : ''
    }, [_vm._v(_vm._s(((_attendance$attendanc9 = attendance.attendances_statuses) === null || _attendance$attendanc9 === void 0 ? void 0 : (_attendance$attendanc10 = _attendance$attendanc9.absents) === null || _attendance$attendanc10 === void 0 ? void 0 : _attendance$attendanc10.attendance_status_count) || 0))]), _c('td', {
      staticClass: "status-half-day"
    }, [_c('b', [_vm._v("Half Day Leave (HD)")])]), _c('td', {
      staticClass: "status-half-day"
    }, [_vm._v(_vm._s(((_attendance$attendanc11 = attendance.attendances_statuses) === null || _attendance$attendanc11 === void 0 ? void 0 : (_attendance$attendanc12 = _attendance$attendanc11.half_day_leave) === null || _attendance$attendanc12 === void 0 ? void 0 : _attendance$attendanc12.attendance_status_count) || 0))]), _c('td', [_c('b', [_vm._v("Total Work Hour")])]), _c('td', [_vm._v(_vm._s(((_attendance$duty_hour2 = attendance.duty_hours) === null || _attendance$duty_hour2 === void 0 ? void 0 : _attendance$duty_hour2.total_worked_hours) || '00:00'))])]), _c('tr', [_c('td', {
      staticClass: "status-delay"
    }, [_c('b', [_vm._v("Delay (D)")])]), _c('td', {
      staticClass: "status-delay"
    }, [_vm._v(_vm._s(((_attendance$attendanc13 = attendance.attendances_statuses) === null || _attendance$attendanc13 === void 0 ? void 0 : (_attendance$attendanc14 = _attendance$attendanc13.delays) === null || _attendance$attendanc14 === void 0 ? void 0 : _attendance$attendanc14.attendance_status_count) || 0))]), _c('td', [_c('b', [_vm._v("Sandwich (S)")])]), _c('td', [_vm._v(_vm._s(((_attendance$attendanc15 = attendance.attendances_statuses) === null || _attendance$attendanc15 === void 0 ? void 0 : (_attendance$attendanc16 = _attendance$attendanc15.sandwich) === null || _attendance$attendanc16 === void 0 ? void 0 : _attendance$attendanc16.attendance_status_count) || 0))]), _c('td', {
      class: attendance.duty_hours && attendance.duty_hours.extra_less_duty_hours && attendance.duty_hours.extra_less_duty_hours[0] === '-' ? 'status-extraless' : null
    }, [_c('b', [_vm._v("Extra/Less Duty Hours")])]), _c('td', {
      class: attendance.duty_hours && attendance.duty_hours.extra_less_duty_hours && attendance.duty_hours.extra_less_duty_hours[0] === '-' ? 'status-extraless' : null
    }, [_vm._v(" " + _vm._s(((_attendance$duty_hour3 = attendance.duty_hours) === null || _attendance$duty_hour3 === void 0 ? void 0 : _attendance$duty_hour3.extra_less_duty_hours) || '00:00') + " ")])]), _c('tr', [_c('td', {
      staticClass: "status-ed"
    }, [_c('b', [_vm._v("Extreme Delay (ED)")])]), _c('td', {
      staticClass: "status-ed"
    }, [_vm._v(_vm._s(((_attendance$attendanc17 = attendance.attendances_statuses) === null || _attendance$attendanc17 === void 0 ? void 0 : (_attendance$attendanc18 = _attendance$attendanc17.extreme_delay) === null || _attendance$attendanc18 === void 0 ? void 0 : _attendance$attendanc18.attendance_status_count) || 0))]), _c('td', [_c('b', [_vm._v("Available / Working Days")])]), _c('td', [_vm._v(_vm._s(attendance.total_office_available_count || 0) + " / " + _vm._s(attendance.total_working_days_count || 0))]), _c('td', [_c('b', [_vm._v("Total Over Time Hour")])]), _c('td', [_vm._v(_vm._s(((_attendance$duty_hour4 = attendance.duty_hours) === null || _attendance$duty_hour4 === void 0 ? void 0 : _attendance$duty_hour4.total_over_time_hours) || '00:00'))])]), _c('tr', [_c('td', [_c('b', [_vm._v("Holiday (H)")])]), _c('td', [_vm._v(_vm._s(((_attendance$attendanc19 = attendance.attendances_statuses) === null || _attendance$attendanc19 === void 0 ? void 0 : (_attendance$attendanc20 = _attendance$attendanc19.holidays) === null || _attendance$attendanc20 === void 0 ? void 0 : _attendance$attendanc20.attendance_status_count) || 0))]), _c('td', [_c('b', [_vm._v("Weekend (W)")])]), _c('td', [_vm._v(_vm._s(((_attendance$attendanc21 = attendance.attendances_statuses) === null || _attendance$attendanc21 === void 0 ? void 0 : (_attendance$attendanc22 = _attendance$attendanc21.weekends) === null || _attendance$attendanc22 === void 0 ? void 0 : _attendance$attendanc22.attendance_status_count) || 0))]), _c('td', [_c('b', [_vm._v("Total Off Day OT")])]), _c('td', [_vm._v(_vm._s(((_attendance$duty_hour5 = attendance.duty_hours) === null || _attendance$duty_hour5 === void 0 ? void 0 : _attendance$duty_hour5.total_off_days_over_time_hours) || '00:00'))])])])])]);
  }), _c('div', {
    staticClass: "text-right mt-3"
  }, [_vm.isAttendanceReportDownloading ? [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Downloading .. ")], 1)] : [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.generateAllAttendanceReport('download');
      }
    }
  }, [_vm._v(" Download PDF ")])]], 2)], 2)]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }